export default __webpack_public_path__ + "static/media/arrow-down-small.52999ce0.svg";